import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import Button from "components/Shared/CustomButtons/Button.js";
import Card from "components/Shared/Card/Card.js";
import CardHeader from "components/Shared/Card/CardHeader/CardHeader.js";
import CardBody from "components/Shared/Card/CardBody/CardBody.js";
import Table from "components/Admin/ArchivedBatches/ArchivedBatches";

import { useDispatch, useSelector } from "react-redux";
import {
  getRejectedBatches,
  reAssignRecycler,
  getRecyclersList,
} from "store/actions/archivedBatches";

const RejectedBatches = () => {
  const dispatch = useDispatch();
  const { rejectedBatches, recyclersList } = useSelector(
    (state) => state.archivedBatches
  );
  const [page, setPage] = useState(
    rejectedBatches ? rejectedBatches.pag.page : 1
  );
  const [amount, setAmount] = useState(
    rejectedBatches ? rejectedBatches.pag.amount : 10
  );
  const [orderField, setOrderField] = useState(
    rejectedBatches ? rejectedBatches.pag.order_field : "created_at"
  );
  const [orderType, setOrderType] = useState(
    rejectedBatches ? rejectedBatches.pag.order_type : "desc"
  );
  const [searchValue, setSearchValue] = useState("");
  const [searchBy, setSearchBy] = useState(
    rejectedBatches ? rejectedBatches.pag.search_by : "branch_name"
  );

  const history = useHistory();

  useEffect(() => {
    dispatch(getRecyclersList(history));
  }, [dispatch]);

  useEffect(() => {
    dispatch(
      getRejectedBatches(
        {
          page,
          amount,
          order_field: orderField,
          order_type: orderType,
          search_value: searchValue,
          search_by: searchBy,
        },
        history,
        3
      )
    );
  }, [page, amount, orderField, orderType, searchValue, dispatch]);

  const showBatchHandler = (id) => {
    history.push("/admin/archived-batches/item/" + id);
  };

  const reAssignRecyclerHandler = (id, recyclerId) => {
    dispatch(
      reAssignRecycler(
        id,
        recyclerId,
        {
          page,
          amount,
          order_field: orderField,
          order_type: orderType,
          search_value: searchValue,
          search_by: searchBy,
        },
        history,
        false
      )
    );
  };

  return (
    <div>
      <Card>
        <CardHeader color="primary">
          <h4>Rejected Archived Batches</h4>
        </CardHeader>
        <CardBody>
          {rejectedBatches && (
            <div>
              <Table
                rows={rejectedBatches.data}
                totalRows={rejectedBatches.pag.total}
                rowsPerPage={amount}
                setRowsPerPage={setAmount}
                order={orderType}
                setOrder={setOrderType}
                orderBy={orderField}
                setOrderBy={setOrderField}
                page={page - 1}
                setPage={setPage}
                showBatch={showBatchHandler}
                searchHandler={setSearchValue}
                searchValue={searchValue}
                selectedSearchBy={searchBy}
                handleSearchByChange={setSearchBy}
                recyclerList={recyclersList}
                reAssignRecycler={reAssignRecyclerHandler}
                isRejected={true}
              />
            </div>
          )}
        </CardBody>
      </Card>
    </div>
  );
};

export default RejectedBatches;
